export default "__VITE_PUBLIC_ASSET__65dd27ba__"